import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    visit(event) {
        const { url, action } = event.params;
        Turbo.visit(url, { action: action });
    }
}
